import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// After index.css and the Bootstrap CDN link so the brand overrides win.
import './theme.css';
import App from './App';
import { QueryClientProvider } from 'react-query';
import { QueryClient } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'boxicons/css/boxicons.min.css';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ToastContainer />
    </QueryClientProvider>
  </React.StrictMode>
);
